import { Injectable } from '@angular/core';
import {TextFormComponent} from '../components/form-types/text/text-form.component';
import {NumberFormComponent} from '../components/form-types/number/number-form.component';
import {DateFormComponent} from '../components/form-types/date/date-form.component';
import {TimeFormComponent} from '../components/form-types/time/time-form.component';
import {EnumFormComponent} from '../components/form-types/enum/enum-form.component';
import {DaterangeFormComponent} from '../components/form-types/daterange/daterange-form.component';
import {BooleanFormComponent} from '../components/form-types/boolean/boolean-form.component';


import { FormParams } from '../interfaces/form-params';
import * as _moment from 'moment';
import { AutocompleteComponent } from '../components/form-types/autocomplete/autocomplete.component';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})

export class DynamicFormBuilder {

  readonly formFieldComponents = {
    string: TextFormComponent,
    number: NumberFormComponent,
    date: DateFormComponent,
    time: TimeFormComponent,
    enum: EnumFormComponent,
    daterange: DaterangeFormComponent,
    bool: BooleanFormComponent,
    autocomplete: AutocompleteComponent,
  };

  constructor() { }

  public setFormValue([key, value]: [string, string], control: FormParams): boolean {

    const {type, name, params, compactValue} = control;
    const lowerName = name.trim().toLowerCase();
    const lowerKey = key.trim().toLowerCase();
    const optionsKeyword = params.optionsKeyword ? params.optionsKeyword.trim().toLowerCase() : 'nothing';


    if (lowerName.includes(lowerKey) || lowerKey.includes(lowerName) || lowerKey.includes(optionsKeyword)) {
      if (type === 'daterange') {
        const altKey = key.includes('start') ? 'start' : 'end';
        if (compactValue) {
          control.compactValue = {
            ...compactValue,
            [altKey]: value,
          };
        } else {
          control.compactValue = {
            [altKey]: value
          };
        }
      } else if (type === 'enum' || type === 'date' || type === 'time') {

        control.compactValue = value;
      } else if (type === 'bool') {
        if (value === 'true') {
          control.value = true;
        } else if (value === 'false') {
          control.value = false;
        }
      } else {
        control.value = value;
      }

      return true;
    }

    return false;
  }

  public createForm([key, value]: [string, string]): FormParams {

    let type = value;
    const name = key;
    const isEnum = value.includes('enum');
    const isAutocomplete = value.includes('autoComplete');

    let component = this.formFieldComponents[value];

    if (isEnum) {
      component = this.formFieldComponents.enum;
    } else if (isAutocomplete) {
      component = this.formFieldComponents.autocomplete;
    }

    let params = {};

    if (isEnum) {
      type = 'enum';
      const optionsKeyword = value.replace('enum_', '');
      params = {
        optionsKeyword
      };
    }

    return {
      name,
      value: null,
      component,
      params,
      type,
    };

  }

  public mapSearchByFields(params, target = {}) {

    Object.keys(params).forEach(key => {
      if (
        (typeof params[key] === 'string' && params[key].length) ||
        (typeof params[key] === 'number') ||
        (typeof params[key] === 'boolean')
      ) {
        if (params[key] === null) {
          return;
        } else {
          target[key] = params[key];
        }
      } else if (params[key] instanceof Date) {
        target[key] = moment(params[key]).format('YYYY-MM-DD');
      } else if (Array.isArray(params[key]) && params[key].length) {
        let idKey;

        const firstItem = params[key][0];
        const firstItemKeys = Object.keys(firstItem);

        for (const item of firstItemKeys) {
          if (item.toLowerCase().includes('id')) {
            idKey = item;
            break;
          }
        }

        const ids = [];
        params[key].forEach(item => {
          ids.push(item[idKey]);
        });

        target[idKey] = ids.join(',');
      }
    });

    return target;
  }

}
